<!-- packages/studio/src/components/army/ArmySettingsForm.vue -->
<template>
  <div class="army-settings">
    <StField label="Grand Alliance">
      <StSelect
        :model-value="modelValue.alliance ?? GrandAlliance.UNKNOWN"
        @update:model-value="patch({ alliance: $event as GrandAlliance })"
      >
        <option v-for="a in alliances" :key="a" :value="a">{{ a }}</option>
      </StSelect>
    </StField>
    <StField label="Keyword" hint="Matches the canonical army when patching">
      <StTextInput
        :model-value="modelValue.keyword ?? ''"
        @update:model-value="patch({ keyword: $event ?? '' })"
      />
    </StField>
    <StCheckbox
      :model-value="modelValue.isArmyOfRenown ?? false"
      @update:model-value="patch({ isArmyOfRenown: $event })"
    >
      Army of Renown
    </StCheckbox>
    <StCheckbox
      :model-value="modelValue.legends ?? false"
      @update:model-value="patch({ legends: $event })"
    >
      Legends
    </StCheckbox>
  </div>
</template>

<script setup lang="ts">
import type { AuthoredArmy } from '@scrolldex/shared';
import { GrandAlliance } from '@scrolldex/shared';
import { StField, StTextInput, StSelect, StCheckbox } from '../ui/index.js';

const props = defineProps<{ modelValue: AuthoredArmy }>();
const emit = defineEmits<{ (e: 'update:modelValue', value: AuthoredArmy): void }>();
const alliances = Object.values(GrandAlliance);
function patch(part: Partial<AuthoredArmy>) {
  emit('update:modelValue', { ...props.modelValue, ...part });
}
</script>

<style scoped>
.army-settings {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-4);
  max-width: 480px;
}
</style>
